export class NewSupplierReferenceRequest {
  isbn!: string;
  supplierId!: string;
  price!: number;
}